import React from 'react';
import convertIcon from './icon';

function Menu() {
  return (
    <svg
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
    >
      <g opacity={0.99}>
        <path
          d="M802.133333 281.6H221.866667c-17.066667 0-29.866667-12.8-29.866667-29.866667 0-17.066667 12.8-29.866667 29.866667-29.866666h580.266666c17.066667 0 29.866667 12.8 29.866667 29.866666 0 17.066667-12.8 29.866667-29.866667 29.866667zM802.133333 524.8H221.866667c-17.066667 0-29.866667-12.8-29.866667-29.866667 0-17.066667 12.8-29.866667 29.866667-29.866666h580.266666c17.066667 0 29.866667 12.8 29.866667 29.866666 0 17.066667-12.8 29.866667-29.866667 29.866667zM802.133333 768H221.866667c-17.066667 0-29.866667-12.8-29.866667-29.866667 0-17.066667 12.8-29.866667 29.866667-29.866666h580.266666c17.066667 0 29.866667 12.8 29.866667 29.866666 0 17.066667-12.8 29.866667-29.866667 29.866667z"
          p-id="851"
        ></path>
      </g>
    </svg>
  );
}

export default convertIcon(Menu);
